module.exports = __webpack_public_path__ + "img/project-3.39d717a3.jpg";